const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./final-scene-all-of-them-are-at-home.gif"),
			class: "image-8",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text slideBottom text-center",
			textIndivData: [
				{
					textData: "काम गरेपछि",
					textClass: "fz-5 m-0 one-line boldtext",
					timestamps: [{ start: 0 }, { start: 1.1 }],
				},
				{
					textData: "घरमा बस्‍न पाए।",
					textClass: "fz-5 m-0 one-line ",
					timestamps: [{ start: 2.5 }, { start: 3.4 }, { start: 4.1 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./s13.ogg"),
			delay: 2000,
		},
	],
}

export default content
